export const BREADCRUMB_LIST = [
  { id: "1", title: "Pedidos", active: false },
  { id: "2", title: "Crear Pedidos v2", active: true },
]

export const MODO_REGION = "region"
export const MODO_GRANJA = "granja"

export const PRODUCTO_TODOS = "todos"

export const ORDEN_PRECIO = "precio"
export const ORDEN_DISPONIBLE = "disp"
export const ORDEN_CALIDAD = "calidad"

export const ORDENES = [
  { value: ORDEN_PRECIO, label: "Precio" },
  { value: ORDEN_DISPONIBLE, label: "Disponible" },
  { value: ORDEN_CALIDAD, label: "Calidad" },
]

// Diferencia contra el mejor precio a partir de la cual se pinta en rojo.
export const DELTA_ALERTA = 1.5
